export default __webpack_public_path__ + "static/media/shield.daa44281.svg";